module.exports = __webpack_public_path__ + "static/media/poly41.94f8d08b.jpg";